import React, { useState, useEffect } from 'react';

// Category data with order and active flags
// You can control sequence by changing the `order` field and hide categories with `active: false`
const transformationCategoriesFallback = [
  {
    id: 'necklace_earrings',
    title: 'Necklace + Earrings',
    order: 1,
    active: true,
    items: [
      {
        sourceImage: '/assets/demo/Necklace_Earring/Necklace_Earring2/Necklace_Earring2_Input_2.jpeg',
        generatedImages: [
          '/assets/demo/Necklace_Earring/Necklace_Earring2/Necklace_Earring2_Output_1.jpeg',
          '/assets/demo/Necklace_Earring/Necklace_Earring2/Necklace_Earring2_Output_2.jpeg',
          // '/assets/demo/Necklace_Earring/Necklace_Earring2/Necklace_Earring2_Output_3.jpeg',
          // '/assets/demo/Necklace_Earring/Necklace_Earring2/Necklace_Earring2_Output_4.jpeg',
          // '/assets/demo/Necklace_Earring/Necklace_Earring2/Necklace_Earring2_Output_5.jpeg',
          // '/assets/demo/Necklace_Earring/Necklace_Earring2/Necklace_Earring2_Output_6.jpeg',
        ],
      },
      {
        sourceImage: '/assets/demo/Necklace_Earring/Necklace_Earring1/Necklace_Earring1_Input_1.jpeg',
        generatedImages: [
          '/assets/demo/Necklace_Earring/Necklace_Earring1/Necklace_Earring1_Output_1.jpeg',
          '/assets/demo/Necklace_Earring/Necklace_Earring1/Necklace_Earring1_Output_2.jpeg',
          '/assets/demo/Necklace_Earring/Necklace_Earring1/Necklace_Earring1_Output_3.jpeg',
          '/assets/demo/Necklace_Earring/Necklace_Earring1/Necklace_Earring1_Output_4.jpeg',
          // '/assets/demo/Necklace_Earring/Necklace_Earring1/Necklace_Earring1_Output_5.jpeg',
          // '/assets/demo/Necklace_Earring/Necklace_Earring1/Necklace_Earring1_Output_6.jpeg',
          // '/assets/demo/Necklace_Earring/Necklace_Earring1/Necklace_Earring1_Output_7.jpeg',
          // '/assets/demo/Necklace_Earring/Necklace_Earring1/Necklace_Earring1_Output_8.jpeg',
        ],
      }
    ],
  },
  {
    id: 'necklaces',
    title: 'Necklaces',
    order: 2,
    active: true,
    items: [
      {
        sourceImage: '/assets/demo/Necklace/Necklace1/Necklace1_Input_2.jpeg',
        generatedImages: [
          '/assets/demo/Necklace/Necklace1/Necklace1_Output_1.jpeg',
          // '/assets/demo/Necklace/Necklace1/Necklace1_Output_2.jpeg',
          // '/assets/demo/Necklace/Necklace1/Necklace1_Output_3.jpeg',
          '/assets/demo/Necklace/Necklace1/Necklace1_Output_4.jpeg',
          // '/assets/demo/Necklace/Necklace1/Necklace1_Output_5.jpeg',
          '/assets/demo/Necklace/Necklace1/Necklace1_Output_6.png',
        ],
      },
      {
        sourceImage: '/assets/demo/Necklace/Necklace2/Necklace2_Input_2.jpeg',
        generatedImages: [
          '/assets/demo/Necklace/Necklace2/Necklace2_Output_1.jpeg',
          // '/assets/demo/Necklace/Necklace2/Necklace2_Output_2.jpeg',
          // '/assets/demo/Necklace/Necklace2/Necklace2_Output_3.jpeg',
          '/assets/demo/Necklace/Necklace2/Necklace2_Output_4.jpeg',
          '/assets/demo/Necklace/Necklace2/Necklace2_Output_5.jpeg',
          // '/assets/demo/Necklace/Necklace2/Necklace2_Output_6.jpeg',
          // '/assets/demo/Necklace/Necklace2/Necklace2_Output_7.jpeg',
          // '/assets/demo/Necklace/Necklace2/Necklace2_Output_8.jpeg',
          '/assets/demo/Necklace/Necklace2/Necklace2_Output_9.jpeg',
          '/assets/demo/Necklace/Necklace2/Necklace2_Output_10.jpeg',
        ],
      },
    ],
  },
  {
    id: 'earrings',
    title: 'Earrings',
    order: 3,
    active: true,
    items: [
      {
        sourceImage: '/assets/demo/Earring/Earring1/Earring1_Input_1.jpeg',
        generatedImages: [
          '/assets/demo/Earring/Earring1/Earring1_Output_1.jpeg',
          // '/assets/demo/Earring/Earring1/Earring1_Output_2.jpeg',
          // '/assets/demo/Earring/Earring1/Earring1_Output_3.jpeg',
          '/assets/demo/Earring/Earring1/Earring1_Output_4.jpeg',
          // '/assets/demo/Earring/Earring1/Earring1_Output_5.jpeg',
          '/assets/demo/Earring/Earring1/Earring1_Output_6.jpeg',
          '/assets/demo/Earring/Earring1/Earring1_Output_7.jpeg',
          // '/assets/demo/Earring/Earring1/Earring1_Output_8.jpeg',
        ],
      },
      {
        sourceImage: '/assets/demo/Earring/Earring2/Earring2_Input_1.jpeg',
        generatedImages: [
          '/assets/demo/Earring/Earring2/Earring2_Output_1.jpeg',
          // '/assets/demo/Earring/Earring2/Earring2_Output_2.jpeg',
          // '/assets/demo/Earring/Earring2/Earring2_Output_3.jpeg',
          // '/assets/demo/Earring/Earring2/Earring2_Output_4.jpeg',
          // '/assets/demo/Earring/Earring2/Earring2_Output_5.jpeg',
          // '/assets/demo/Earring/Earring2/Earring2_Output_6.jpeg',
          '/assets/demo/Earring/Earring2/Earring2_Output_7.jpeg',
          '/assets/demo/Earring/Earring2/Earring2_Output_8.jpeg',
          '/assets/demo/Earring/Earring2/Earring2_Output_9.jpeg',
        ],
      }
    ],
  },
  {
    id: 'mangalsutra',
    title: 'Mangalsutra',
    order: 4,
    active: true,
    items: [
      {
        sourceImage: '/assets/demo/Mangalsutra/Mangalsutra1/Mangalsutra1_Input_2.jpeg',
        generatedImages: [
          '/assets/demo/Mangalsutra/Mangalsutra1/Mangalsutra1_Output_1.jpeg',
          '/assets/demo/Mangalsutra/Mangalsutra1/Mangalsutra1_Output_2.jpeg',
          // '/assets/demo/Mangalsutra/Mangalsutra1/Mangalsutra1_Output_3.jpeg',
          // '/assets/demo/Mangalsutra/Mangalsutra1/Mangalsutra1_Output_4.jpeg',
          // '/assets/demo/Mangalsutra/Mangalsutra1/Mangalsutra1_Output_5.jpeg',
          '/assets/demo/Mangalsutra/Mangalsutra1/Mangalsutra1_Output_6.jpeg',
        ],
      },
      {
        sourceImage: '/assets/demo/Mangalsutra/Mangalsutra2/Mangalsutra2_Input_1.jpeg',
        generatedImages: [
          '/assets/demo/Mangalsutra/Mangalsutra2/Mangalsutra2_Output_1.jpeg',
          // '/assets/demo/Mangalsutra/Mangalsutra2/Mangalsutra2_Output_2.jpeg',
          '/assets/demo/Mangalsutra/Mangalsutra2/Mangalsutra2_Output_3.jpeg',
          '/assets/demo/Mangalsutra/Mangalsutra2/Mangalsutra2_Output_4.jpeg',
          // '/assets/demo/Mangalsutra/Mangalsutra2/Mangalsutra2_Output_5.jpeg',
          '/assets/demo/Mangalsutra/Mangalsutra2/Mangalsutra2_Output_6.jpeg',
        ],
      }
    ],
  },
  {
    id: 'rings',
    title: 'Rings',
    order: 5,
    active: true,
    items: [
      {
        sourceImage: '/assets/demo/Rings/Ring1/Ring1_Input_2.jpeg',
        generatedImages: [
          '/assets/demo/Rings/Ring1/Ring1_Output_1.jpeg',
          '/assets/demo/Rings/Ring1/Ring1_Output_2.jpeg',
          '/assets/demo/Rings/Ring1/Ring1_Output_3.jpeg',
          '/assets/demo/Rings/Ring1/Ring1_Output_4.jpeg',
        ],
      },
      {
        sourceImage: '/assets/demo/Rings/Ring2/Ring2_Input_2.jpeg',
        generatedImages: [
          '/assets/demo/Rings/Ring2/Ring2_Output_1.jpeg',
          '/assets/demo/Rings/Ring2/Ring2_Output_2.jpeg',
          '/assets/demo/Rings/Ring2/Ring2_Output_3.png',
          '/assets/demo/Rings/Ring2/Ring2_Output_4.jpeg',
        ],
      },
    ],
  },
  {
    id: 'bangles',
    title: 'Bangles',
    order: 6,
    active: true,
    items: [
      {
        sourceImage: '/assets/demo/Bangles/Bangles1/Bangles1_Input_1.jpeg',
        generatedImages: [
          '/assets/demo/Bangles/Bangles1/Bangles1_Output_1.jpeg',
          // '/assets/demo/Bangles/Bangles1/Bangles1_Output_2.jpeg',
          // '/assets/demo/Bangles/Bangles1/Bangles1_Output_3.jpeg',
          // '/assets/demo/Bangles/Bangles1/Bangles1_Output_4.jpeg',
          '/assets/demo/Bangles/Bangles1/Bangles1_Output_5.jpeg',
          '/assets/demo/Bangles/Bangles1/Bangles1_Output_6.jpeg',
        ],
      },
      {
        sourceImage: '/assets/demo/Bangles/Bangles2/Bangles2_Input_1.jpeg',
        generatedImages: [
          '/assets/demo/Bangles/Bangles2/Bangles2_Output_1.jpeg',
          // '/assets/demo/Bangles/Bangles2/Bangles2_Output_2.jpeg',
          '/assets/demo/Bangles/Bangles2/Bangles2_Output_4.jpeg',
          '/assets/demo/Bangles/Bangles2/Bangles2_Output_5.jpeg',
        ],
      },
    ],
  },
  {
    id: 'bracelets',
    title: 'Bracelets',
    order: 7,
    active: false,
    items: [
      {
        sourceImage: '/assets/demo/Bracelets/Bracelet1/Bracelet1_Input_1.jpeg',
        generatedImages: [
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_1.jpeg',
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_2.jpeg',
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_3.jpeg',
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_4.jpeg',
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_5.jpeg',
        ],
      },
      {
        sourceImage: '/assets/demo/Bracelets/Bracelet1/Bracelet1_Input_2.jpeg',
        generatedImages: [
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_1.jpeg',
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_2.jpeg',
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_3.jpeg',
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_4.jpeg',
          '/assets/demo/Bracelets/Bracelet1/Bracelet1_Output_5.jpeg',
        ],
      },
      {
        sourceImage: '/assets/demo/Bracelets/Bracelet2/Bracelet2_Input_1.jpeg',
        generatedImages: [
          '/assets/demo/Bracelets/Bracelet2/Bracelet2_Output_1.jpeg',
          '/assets/demo/Bracelets/Bracelet2/Bracelet2_Output_2.jpeg',
          '/assets/demo/Bracelets/Bracelet2/Bracelet2_Output_3.jpeg',
          '/assets/demo/Bracelets/Bracelet2/Bracelet2_Output_4.jpeg',
        ],
      },
      {
        sourceImage: '/assets/demo/Bracelets/Bracelet2/Bracelet2_Input_2.jpeg',
        generatedImages: [
          '/assets/demo/Bracelets/Bracelet2/Bracelet2_Output_1.jpeg',
          '/assets/demo/Bracelets/Bracelet2/Bracelet2_Output_2.jpeg',
          '/assets/demo/Bracelets/Bracelet2/Bracelet2_Output_3.jpeg',
          '/assets/demo/Bracelets/Bracelet2/Bracelet2_Output_4.jpeg',
        ],
      },
    ],
  },
];

const TransformationCard = ({ category }) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [activeGeneratedIndex, setActiveGeneratedIndex] = useState(0);
  const [mainLoaded, setMainLoaded] = useState(false);

  const activeItem = category?.items?.[activeItemIndex];

  // Preload generated images for the active item and the next item to avoid delay
  useEffect(() => {
    if (!activeItem || !activeItem.generatedImages) return;
    setMainLoaded(false);

    // preload main image (current generated)
    const mainImg = new Image();
    mainImg.onload = () => setMainLoaded(true);
    mainImg.src = activeItem.generatedImages[activeGeneratedIndex];

    // preload other generated images of the active item
    activeItem.generatedImages.forEach((src) => {
      if (src !== mainImg.src) {
        const i = new Image();
        i.src = src;
      }
    });

    // preload next source's generated images (if any)
    const next = category?.items?.[activeItemIndex + 1];
    if (next && next.generatedImages) {
      next.generatedImages.forEach((src) => { const i = new Image(); i.src = src; });
    }

    return () => { mainImg.onload = null; };
  }, [activeItemIndex, activeGeneratedIndex, activeItem, category?.items]);

  if (!category || !category.items || category.items.length === 0) return null;

  const hasMultipleSources = category.items.length > 1;

  // Calculate total AI photos for this category
  const totalAiPhotos = category.items.reduce((acc, item) => acc + item.generatedImages.length, 0);

  const handleSourceClick = (idx) => {
    setActiveItemIndex(idx);
    setActiveGeneratedIndex(0);
  };

  return (
    <div className="tf-card">
      {/* Card Header */}
      <div className="tf-card-header d-flex justify-content-between align-items-center mb-3">
        <h3 className="tf-card-title">{category.title}</h3>
        <span className="tf-ai-badge">{totalAiPhotos} AI photos</span>
      </div>

      {/* Card Body: Left source + Arrow + Right generated */}
      <div className="tf-card-body">

        {/* LEFT: Source panel */}
        <div className="tf-source-panel">

          {/* Product image */}
          <div className="tf-source-img-wrap">
            <img src={activeItem.sourceImage} alt="Source product" className="tf-source-img" />
          </div>
          {/* Label */}
          <div className={`tf-label mt-2 ${hasMultipleSources ? 'mb-2' : ''}`}>
            <span className="tf-dot tf-dot-gray"></span>
            {hasMultipleSources ? 'SOURCE PHOTOS' : 'SOURCE PHOTO'}
          </div>

          {/* Source Thumbnails */}
          {hasMultipleSources && (
            <div className="tf-thumbnails">
              {category.items.map((item, idx) => (
                <button
                  key={idx}
                  className={`tf-thumb-btn ${idx === activeItemIndex ? 'active' : ''}`}
                  onClick={() => handleSourceClick(idx)}
                >
                  <img src={item.sourceImage} alt={`Source ${idx + 1}`} className="tf-thumb-img" />
                </button>
              ))}
            </div>
          )}
        </div>

        {/* CENTER: Arrow — aligned to top-bar level */}
        <div className="tf-arrow-col">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#6318C6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        {/* RIGHT: Generated panel */}
        <div className="tf-generated-panel">
          {/* Main big generated image */}
          <div className="tf-generated-img-wrap position-relative">
            <img
              src={activeItem.generatedImages[activeGeneratedIndex]}
              alt="AI Generated"
              className="tf-generated-img"
              style={{ opacity: mainLoaded ? 1 : 0.4, transition: 'opacity 200ms ease-in-out' }}
            />
            {!mainLoaded && (
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'rgba(0,0,0,0.5)', color: '#fff', padding: '6px 10px', borderRadius: 6, fontSize: 12 }}>
                Loading...
              </div>
            )}
            <span className="tf-photos-badge position-absolute top-0 end-0 m-2">
              {activeItem.generatedImages.length} photos
            </span>
          </div>

          {/* AI Generated label */}
          <div className="tf-label mt-2 mb-2">
            <span className="tf-dot tf-dot-purple"></span>
            AI GENERATED
          </div>

          {/* Thumbnails */}
          <div className="tf-thumbnails">
            {activeItem.generatedImages.map((img, idx) => (
              <button
                key={idx}
                className={`tf-thumb-btn ${idx === activeGeneratedIndex ? 'active' : ''}`}
                onClick={() => setActiveGeneratedIndex(idx)}
              >
                <img src={img} alt={`Generated ${idx + 1}`} className="tf-thumb-img" />
              </button>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

const TransformationSection = () => {
  // Sort categories by order field
  const sortedCategories = [...transformationCategoriesFallback].sort(
    (a, b) => (a.order || 0) - (b.order || 0)
  );

  return (
    <section className="tf-section" id="transformation-section">
      <div className="container-fluid tf-container">
        {/* Section Header */}
        <div className="text-center mb-5">
          <div className="tf-section-badge d-inline-block mb-3">The Transformation</div>
          <h2 className="tf-section-title mb-3">
            Every piece. Every style. Transformed.
          </h2>
          <p className="tf-section-subtitle">
            See how each piece goes from a simple product photo to professional<br className="d-none d-md-block" />
            model imagery — in seconds, with no studio required.
          </p>
        </div>



        {/* Cards Grid */}
        <div className="tf-grid">
          {sortedCategories.filter(c => c.active !== false).map((cat) => (
            <TransformationCard key={cat.id} category={cat} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TransformationSection;
